<template>
	<div class="pdfWrapper">
		<!-- <pdf
			v-for="i in numPages"
			:key="i"
			:src="loadingTask"
			:page="i"
		></pdf> -->
		<vue-pdf-embed
			style="width: 100%; height:100%;"
			ref="pdfRef"
			:source="source"
			:page="page"
			@rendered="handleDocumentRender"
		/>
	</div>
</template>

<script>
import constants from '@/api';
import pdf from 'vue-pdf';
// import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { setTimeout, clearTimeout } from 'timers';
import axios from 'axios';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
	created() {},
	components: {
		// pdf,
		VuePdfEmbed,
	},
	data() {
		return {
			loadingTask: undefined,
			numPages: undefined,
			source: "",
			page: null,
			pageCount: 1,
		};
	},
	methods: {
		handleDocumentRender(args) {
			this.isLoading = false;
			this.pageCount = this.$refs.pdfRef.pageCount;
		},
	},
	computed: {},
	mounted() {
		const CancelToken = axios.CancelToken;
		let cancel, timeout;
		try {
			axios({
				method: 'get',
				headers: {
					Authorization: this.$store.getters.authToken,
				},
				url:
					constants.UTILITY_OG_FILE +
					'?uuid=' +
					(this.isOriginalFile
						? this.selectedFile.originalFilename.split('.')[0]
						: this.selectedFile.filename.split('.')[0]),
				responseType: 'arraybuffer',
				cancelToken: new CancelToken(function(c) {
					cancel = c;
					// console.log(c);
				}),
			})
				.then(res => {
					clearTimeout(timeout);
					// this.loadingTask = pdf.createLoadingTask(new Uint8Array(res.data));
					// this.loadingTask.then(pdf => {
					// 	this.numPages = pdf.numPages;
					// });

					this.source = new Uint8Array(res.data);
				})
				.catch(e => {
					console.log('Get original file error', e);
				});
			timeout = setTimeout(() => {
				cancel();
			}, 7000);
		} catch (e) {
			console.log('Get original file error', e);
		}
	},
	props: {
		selectedFile: { required: true },
		isOriginalFile: { required: false, default: false },
	},
};
</script>

<style lang="scss" scoped>
.pdfWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	// padding: 10px;
}
</style>
